import { useGuestSiteUnlockStateQuery } from './GuestSiteUnlockState.graphql.generated';
import { useMcpPreviewForceSsr } from '@shared/context/mcpPreviewForceSsr';

// PLAN-17 step-2: canonical unlock-state read, replacing EventWebsiteGuest's activeSession.
// ssr:false for normal guests (the MCP preview sets ssr:true — see below). SSR is always anonymous (auth token is client-side only), so the SSR HTML renders
// the locked view and this corrects it post-hydration; firing CSR attaches the token via authLink
// automatically (no auth-upgrade refetch needed). While loading, `hasUnlocked` is undefined —
// gate decisions must treat that as indeterminate (defer gating), not as locked.
// NOTE: joinEvent/logout create a NEW EventSession id, so cache normalization never updates this
// query's result — unlock/logout flows must refetchQueries(['GuestSiteUnlockState']).
// MCP preview: resolve unlock + canPreviewDraft during SSR (ssr:true) off the prewarmed cache — see MCP_PREVIEW.md#cache-first-reads.
export const useGuestSiteUnlockState = (eventHandle: string | undefined) => {
  const forceSsr = useMcpPreviewForceSsr();
  const { data, loading } = useGuestSiteUnlockStateQuery({
    variables: { eventHandle: eventHandle ?? '' },
    batchMode: 'fast',
    ssr: forceSsr,
    skip: !eventHandle,
  });

  return {
    hasUnlocked: data?.eventByName?.activeSession?.hasUnlocked,
    // True only for a live draft-preview session; feeds the unpublished-site gate — see MCP_PREVIEW.md#draft-gate.
    canPreviewDraft: data?.eventByName?.activeSession?.canPreviewDraft ?? false,
    isUnlockStateLoading: loading && !data,
  };
};
